<p-dialog
  [header]="title"
  [visible]="visible"
  (visibleChange)="!$event && close()"
  [modal]="true"
  [dismissableMask]="!saving"
  appendTo="body"
  [style]="{width: '560px', maxWidth: '95vw'}"
  [draggable]="false"
  [resizable]="false"
  [closable]="!saving"
  [closeOnEscape]="!saving"
>
  @if (!type) {
  <div class="widget-choices">
    @for (choice of choices; track choice.type) {
    <button
      type="button"
      class="widget-choice"
      (click)="choose(choice.type)"
    >
      <i [class]="choice.icon" aria-hidden="true"></i>
      <span class="widget-choice-label">{{ choice.label }}</span>
      <span class="widget-choice-description">{{ choice.description }}</span>
    </button>
    }
  </div>
  <p class="text-muted small mt-3 mb-0">Alles, was du hier hinzufügst, siehst nur du.</p>
  } @else {
  <form
    #widgetForm="ngForm"
    (ngSubmit)="save()"
  >
    <fieldset
      [disabled]="saving"
      class="border-0 p-0 m-0"
    >
      @switch (type) {
      @case ('weather') {
      <div class="mb-3">
        <label class="form-label" for="widget-postal-code">Postleitzahl</label>
        <input
          id="widget-postal-code"
          name="postalCode"
          class="form-control"
          inputmode="numeric"
          autocomplete="postal-code"
          maxlength="5"
          placeholder="z. B. 10115"
          [(ngModel)]="postalCode"
          required
        >
        <div class="form-text">Deutsche Postleitzahl. Der Ort wird automatisch ermittelt. Wetterdaten: <a href="https://www.dwd.de" target="_blank" rel="noopener noreferrer">Deutscher Wetterdienst</a> über <a href="https://brightsky.dev" target="_blank" rel="noopener noreferrer">Bright Sky</a>, Ortsdaten: <a href="https://www.geonames.org" target="_blank" rel="noopener noreferrer">GeoNames</a>, jeweils <a href="https://creativecommons.org/licenses/by/4.0/deed.de" target="_blank" rel="noopener noreferrer">CC BY 4.0</a>.</div>
      </div>
      }
      @case ('clock') {
      <div class="mb-3">
        <span class="form-label d-block" id="widget-clock-style">Darstellung</span>
        <div class="widget-segment" role="radiogroup" aria-labelledby="widget-clock-style">
          <label [class.active]="clockStyle === 'digital'">
            <input type="radio" name="clockStyle" value="digital" [(ngModel)]="clockStyle">
            <i class="ri-timer-flash-line" aria-hidden="true"></i>Digital
          </label>
          <label [class.active]="clockStyle === 'analog'">
            <input type="radio" name="clockStyle" value="analog" [(ngModel)]="clockStyle">
            <i class="ri-time-line" aria-hidden="true"></i>Analog
          </label>
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label" for="widget-time-zone">Zeitzone</label>
        <p-select
          inputId="widget-time-zone"
          name="timeZone"
          [options]="timeZones"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="timeZone"
          [filter]="true"
          filterBy="label"
          filterPlaceholder="Ort suchen, z. B. New York"
          appendTo="body"
          styleClass="w-100"
        ></p-select>
      </div>
      <label class="d-flex align-items-center gap-2 mb-2">
        <input type="checkbox" name="showDate" [(ngModel)]="showDate">Datum anzeigen
      </label>
      <label class="d-flex align-items-center gap-2 mb-3">
        <input type="checkbox" name="showSeconds" [(ngModel)]="showSeconds">Sekunden anzeigen
      </label>
      }
      @case ('note') {
      @if (!tileId) {
      <div class="mb-3">
        <label class="form-label" for="widget-note-text">Notiz</label>
        <textarea
          id="widget-note-text"
          name="noteText"
          class="form-control"
          rows="4"
          maxlength="5000"
          placeholder="Optional, du kannst auch direkt in der Kachel schreiben."
          [(ngModel)]="noteText"
        ></textarea>
      </div>
      }
      }
      }
      <div class="mb-3">
        <label class="form-label" for="widget-name">Titel <span class="text-muted">(optional)</span></label>
        <input
          id="widget-name"
          name="name"
          class="form-control"
          maxlength="200"
          [placeholder]="namePlaceholder"
          [(ngModel)]="name"
        >
      </div>
      <div class="text-muted small">Nur für dich sichtbar</div>
    </fieldset>
    @if (error) { <p class="text-danger mt-3 mb-0" role="alert">{{ error }}</p> }
    <div class="d-flex flex-wrap gap-2 justify-content-end mt-3">
      @if (tileId) {
      <button
        pButton
        type="button"
        severity="danger"
        [outlined]="true"
        class="me-auto"
        [disabled]="saving"
        (click)="delete()"
      >
        <i class="ri-delete-bin-line me-2"></i>{{ confirmDelete ? 'Löschen bestätigen' : 'Löschen' }}
      </button>
      } @else {
      <button
        pButton
        type="button"
        [text]="true"
        class="me-auto"
        [disabled]="saving"
        (click)="back()"
      >
        <i class="ri-arrow-left-line me-2"></i>Zurück
      </button>
      }
      <button
        pButton
        type="button"
        [outlined]="true"
        [disabled]="saving"
        (click)="close()"
      >Abbrechen</button>
      <button
        pButton
        type="submit"
        [loading]="saving"
        [disabled]="saving || (type === 'weather' && !validPostalCode)"
      >
        <i class="me-2" [class]="tileId ? 'ri-save-line' : 'ri-add-line'"></i>{{ tileId ? 'Speichern' : 'Hinzufügen' }}
      </button>
    </div>
  </form>
  }
</p-dialog>
